/*
 * @Description: Jerry Create File
 * @Version: 1.0
 * @Autor: Jerry
 * @Date: 2022-03-07 08:55:57
 * @LastEditors: Jeson
 * @LastEditTime: 2022-06-13 14:10:30
 */
const Base = [

  '商品名称',
  '批准文号',
  '包装规格',
  '效期优于',
  '生产日期',
  '医保范围',
  '医保类型',
  '条形编码',
  '医保代码',

  '经营范围'
]

const Extend = [
  '商品分类',
  '服用天数',
  '盒装数量',
  '关联商品',
  '关联理由',
  '功能主治',
  '用法用量',
  '用药嘱咐',
  '用药禁忌',
  '件装数量'
]

export { Base, Extend }
